import {
  get,
  post
} from './axios.js'
import qs from 'qs'
const apiUrl = 'https://app.yide111.com/api/dhm.art.app'
// const apiUrl = 'http://192.168.1.104:8092/dhm.art.app'

// 获取用户list
export const getUserList = params => get('/userList', qs.stringify(params))
// 提交用户信息
export const updateUserInfo = params => post('/updateUserInfo', qs.stringify(params))

// 全部好课
export const findAllCurriculum = params => get(apiUrl + '/homeClass/list', params)
// 更多好课
export const findAllCurriculums = params => get(apiUrl + '/classDetails/listByFamous', params)
// 书法学
export const findAllCalligraphy = params => get(apiUrl + '/homeNotice/listAll', params)
// 课程详情
export const getDetails = params => get(apiUrl + '/classDetails/detailsInfo', params)
// 发送验证码
export const sendCode = params => get(apiUrl + '/user/sendCode', params)
// 获取二维码
export const sendqrCode = params => get(apiUrl + '/user/genLoginCode', params)
// 获取二维码信息
export const sendCodeInfo = params => get(apiUrl + '/user/getCodeInfo', params)
// 登录
export const login = params => get(apiUrl + '/user/phoneLogin', params)
// 推荐课程
export const getRecommendList = params => get(apiUrl + '/classDetails/tClassDetails', params)
// 书法字典类型
export const getDictionaryType = params => get(apiUrl + '/pubType/listToWordType', params)
// 书法字典查询
export const getCalligraphyList = params => get(apiUrl + '/dict/selectCalliWord', params)
// 汉语字典查询
export const getChineseList = params => get(apiUrl + '/dictWordInfo/wordInfoNew', params)
// 集字字典查询
export const getSetWordList = params => get(apiUrl + '/collWord/selectWord', params)
// 生成集字
export const upDataSetWordList = params => post(apiUrl + '/collWord/downPic?type=' + params.type, params.list)
// 校内课程
export const inSchoolClass = params => get(apiUrl + '/classDetails/listAll', params)
// 保存播放记录
export const saveRecord = params => get(apiUrl + '/classStuSign/updateStuTime', params)
/**
 * 字帖部分API
 * @param {*} params
 * @returns
 */
// 字帖列表
export const famousPostList = params => get(apiUrl + '/dictCopybook/listAll', params)
// 字帖列表
export const famousPostDetail = params => get(apiUrl + '/dictCopybook/getById', params)
// 推荐字帖列表
export const findOtherList = params => get(apiUrl + '/dictCopybook/recommend', params)
// 字帖收藏
export const famousPostCollect = params => get(apiUrl + '/dict/collection', params)
// 字帖取消收藏
export const famousPostUnCollect = params => get(apiUrl + '/dict/unCollection', params)

/**
 * 赛事部分API
 * @param {*} params
 * @returns
 */
// 赛事列表
export const matchList = params => get(apiUrl + '/matchInfo/listInfo', params)
// 赛事详情
export const matchDetail = params => get(apiUrl + '/matchInfo/details', params)

/**
 * 我的部分API
 */
// 个人信息
export const getUserInfo = params => get(apiUrl + '/user/userDetail', params)
// 我的课程列表
export const myClassList = params => get(apiUrl + '/classDetails/listByUserId', params)
// 我的奖学金
export const myScholarshipInfo = params => get(apiUrl + '/user/userBonusDetail', params)
// 我的奖学金明细
export const myScholarshipList = params => get(apiUrl + '/front/spread/commissionpage/1', params)
// 我的订单列表
export const myOrderList = params => get(apiUrl + '/front/order/list', params)
// 提交个人信息
export const saveUserInfo = params => post(apiUrl + '/user/saveInfo', params)
// 加盟提交
export const saveHomeFeedback = params => post(apiUrl + '/home/homeJoinInfo/saveHomeFeedback', params)

/**
 * 搜索部分
 * @param {*} params
 * @returns
 */
// 搜索
export const searchList = params => get(apiUrl + '/classDetails/searchClass', params)

/**
 * 支付部分
 */
// 支付宝支付
export const aliPayH5 = params => get(apiUrl + '/h5/pay/aliPay', params)
// 微信支付
export const wxPayH5 = params => get(apiUrl + '/h5/pay/wxPay', params)
// 会员价格列表
export const vipInfoList = params => get(apiUrl + '/userVipInfo/listPrice', params)
// 会员价格列表
export const callBackPay = params => get(apiUrl + '/pay/callBack?orderId=' + params)
// 课程购买列表
export const buyDetails = params => get(apiUrl + '/cls/classStuSection/buyDetails', params)
// 课程购买列表
export const clsConfirm = params => get(apiUrl + '/front/order/cls/confirm', params)
// 课程购买列表
export const clsCreate = params => post(apiUrl + '/front/order/cls/create/' + params.orderId, params)



// WEBPACK FOOTER //
// ./src/axios/api.js